import { useState } from 'react';
import { Input } from '@paulownia/shared/components/ui/input';
import { Label } from '@paulownia/shared/components/ui/label';

interface UnitFieldsProps {
  price?: number;
  onPriceChange: (price: number | undefined) => void;
}

export function UnitFields({ price, onPriceChange }: UnitFieldsProps) {
  const [priceInput, setPriceInput] = useState(price ? String(price) : '');

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="unit-price">Prix unitaire (€) *</Label>
        <Input
          id="unit-price"
          type="text"
          inputMode="decimal"
          value={priceInput}
          onChange={(e) => {
            const val = e.target.value;
            // Allow digits, one dot or comma, and up to 2 decimal places
            if (val === '' || /^\d*[.,]?\d{0,2}$/.test(val)) {
              setPriceInput(val);
              const normalized = val.replace(',', '.');
              const parsed = parseFloat(normalized);
              onPriceChange(val === '' ? undefined : (isNaN(parsed) ? undefined : parsed));
            }
          }}
          placeholder="ex: 24.00"
        />
        <p className="text-xs text-gray-500">
          Prix par pièce affiché au client.
        </p>
      </div>
    </div>
  );
}
